import { styled } from '@mui/material';
import { useState } from 'react';

import { Radio, RadioGroup, Text } from 'shell/components';

const RadioDemo = () => {
    const [selected, setSelected] = useState('');

    return (
        <>
            <Text variant={'sh1'}>Radio</Text>

            <CustomRadioGroup>
                <Radio value={'option-1'} />
                <Radio value={'option-2'} />
                <Radio disabled value={'option-3'} />
            </CustomRadioGroup>

            <CustomRadioGroup defaultValue={'option-1'}>
                <Radio value={'option-1'} label={'Label'} />
                <Radio value={'option-2'} label={'Label'} />
                <Radio disabled value={'option-3'} label={'Label'} />
            </CustomRadioGroup>

            <CustomRadioGroup value={selected} onChange={(e) => setSelected(e.target.value)}>
                <Radio error={!selected} value={'option-1'} label={'Label'} />
                <Radio error={!selected} value={'option-2'} label={'Label'} />
            </CustomRadioGroup>

            <CustomRadioGroup defaultValue={'option-1'}>
                <Radio value={'option-1'} label={'Label'} labelPlacement={'start'} />
                <Radio value={'option-2'} label={'Label'} labelPlacement={'start'} />
                <Radio disabled value={'option-3'} label={'Label'} labelPlacement={'start'} />
            </CustomRadioGroup>
        </>
    );
};

const CustomRadioGroup = styled(RadioGroup)(({ theme }) => ({
    gap: theme.spacing(1),
}));

export default RadioDemo;
